var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90323 2.94355C4.86559 0.981183 7.23118 0 10 0C12.7688 0 15.121 0.981183 17.0565 2.94355C19.0188 4.87903 20 7.23118 20 10C20 12.7688 19.0188 15.1344 17.0565 17.0968C15.121 19.0323 12.7688 20 10 20C7.23118 20 4.86559 19.0323 2.90323 17.0968C0.967742 15.1344 0 12.7688 0 10C0 7.23118 0.967742 4.87903 2.90323 2.94355ZM12.5 4.91935C11.8011 4.22043 10.9677 3.87097 10 3.87097C9.03226 3.87097 8.19893 4.22043 7.5 4.91935C6.80108 5.61828 6.45161 6.45161 6.45161 7.41935C6.45161 8.3871 6.80108 9.22043 7.5 9.91936C8.19893 10.6183 9.03226 10.9677 10 10.9677C10.9677 10.9677 11.8011 10.6183 12.5 9.91936C13.1989 9.22043 13.5484 8.3871 13.5484 7.41935C13.5484 6.45161 13.1989 5.61828 12.5 4.91935ZM4.1129 15C5.64516 16.828 7.60753 17.7419 10 17.7419C12.3925 17.7419 14.3548 16.828 15.8871 15C15.5108 14.2742 14.9731 13.6962 14.2742 13.2661C13.5753 12.8091 12.7957 12.5806 11.9355 12.5806C11.8548 12.5806 11.7608 12.5941 11.6532 12.621C11.0887 12.8091 10.5376 12.9032 10 12.9032C9.46237 12.9032 8.91129 12.8091 8.34677 12.621C8.23925 12.5941 8.14516 12.5806 8.06452 12.5806C7.2043 12.5806 6.42473 12.8091 5.72581 13.2661C5.02688 13.6962 4.48925 14.2742 4.1129 15Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.d7170e8adc916dc901f53d6a4a0a2100.svg";
export { ForwardRef as ReactComponent };